import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBKfb2o1NCiZUfjhlJ7ryHO-1DGqSEr85I",
  authDomain: "upmt-1.firebaseapp.com",
  projectId: "upmt-1",
  storageBucket: "upmt-1.firebasestorage.app",
  messagingSenderId: "216644314542",
  appId: "1:216644314542:web:fbb430419ad8479733143f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);

// For development, you can connect to Firebase emulators
// Uncomment these lines if you're using Firebase emulators locally
// if (process.env.NODE_ENV === 'development') {
//   connectFirestoreEmulator(db, 'localhost', 8080);
//   connectAuthEmulator(auth, 'http://localhost:9099');
// }

export default app;

/*
=== FIREBASE SETUP INSTRUCTIONS ===

1. Go to https://console.firebase.google.com/
2. Create a new project or select existing project
3. Enable Firestore Database:
   - Go to Firestore Database
   - Click "Create database"
   - Choose "Start in test mode" for development
   - Select a location for your database

4. Enable Authentication:
   - Go to Authentication
   - Click "Get started"
   - Go to "Sign-in method" tab
   - Enable "Email/Password" provider

5. Get your config:
   - Go to Project Settings (gear icon)
   - Scroll down to "Your apps" section
   - Click on "</>" (Web) to add a web app
   - Register your app with name "UPM Traders"
   - Copy the config object and replace the placeholder values above

6. Set up security rules (optional, for production):
   - In Firestore, go to Rules tab
   - Update rules to secure your data

7. Create admin user:
   - The system will automatically create a default admin on first run
   - Default credentials: admin@upmtraders.com / UpmTraders2024!
   - Change these credentials immediately after first login

8. Update .env file (optional):
   - Create .env file in project root
   - Add your Firebase config as environment variables
   - Update this file to use process.env variables
*/